import styled, { css } from 'styled-components/macro';

const FieldLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0;

  ${props =>
    props.$flexSpace &&
    css`
      display: flex;
      justify-content: space-between;
    `}
`;

export default FieldLabel;
